// 试题类型
class SubjectType {
    static single = 1; // 单选题
    static multiple = 2; // 多选题
    static fill = 3; // 填空题
    static judge = 4; // 判断题
    static answer = 5; // 回答题
    static complex = 6; // 复合题
}

// 公共题库的题型
class SubjectTypeCs {
    static single = "0"; // 单选题
    static multiple = "1"; // 多选题
    static fill = "3"; // 填空题
    static judge = "5"; // 判断题
    static answer = "4"; // 回答题
}

// 机构类型
class SourceType {
    static public = 1; // 公共题库
    static organ = 2; // 机构题库2
}

export { SubjectType, SourceType }
